<div #contentWrapperRef class="content-wrapper {{wrapperClass()}}"
     [class.has-side-panel]="hasSidePanel()">
  <ng-content select="app-topbar"></ng-content>
  <div class="content-wrapper__inner">
    <div class="content-wrapper__left {{leftClass()}}" [hidden]="!hasSidePanel()">
      <div class="content-wrapper__side-panel" #sidePanelRef>
        <ng-content select="app-side-panel"></ng-content>
        <ng-content select="[contentLeft]"></ng-content>
      </div>
    </div>
    <div class="content-wrapper__right {{rightClass()}}">
      <ng-content></ng-content>
    </div>
  </div>
</div>
